export type UrlParts = {
  path: string;
  query: string;
  /** Leading `#` included, so it can be appended back as is. */
  hash: string;
};

export const splitUrl = (url: string): UrlParts => {
  const [beforeHash = '', ...hashParts] = url.split('#');
  const [path = '', ...queryParts] = beforeHash.split('?');

  return {
    path,
    query: queryParts.join('?'),
    hash: hashParts.length ? `#${hashParts.join('#')}` : '',
  };
};
